import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { ParamService } from './param.service';
import { Param } from './param';

@Injectable({ providedIn: 'root'})
export class ParamResolver implements Resolve<Observable<Param[]>>{

    constructor(private service: ParamService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Param[]> {
        return this.service.findAll();
    }
}